import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=c0976a7e&scoped=true"
import script from "./Registration.vue?vue&type=script&setup=true&lang=ts"
export * from "./Registration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Registration.vue?vue&type=style&index=0&id=c0976a7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0976a7e",
  null
  
)

export default component.exports